module.exports = __webpack_public_path__ + "static/img/DSC_2661.2f84b8c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/DSC_2661.jpg
// module id = 269
// module chunks = 0